import { createFileRoute } from "@tanstack/react-router";
import type { DateRange } from "../hooks/useAnalyticsDashboard";

export const Route = createFileRoute("/$orgSlug/admin/analytics")({
  validateSearch: (search: Record<string, unknown>): { range?: DateRange } => ({
    range: ["7d", "30d", "90d", "all"].includes(search.range as string)
      ? (search.range as DateRange)
      : undefined,
  }),
  // Component moved to $orgSlug.admin.analytics.lazy.tsx for code splitting
});
